import React from 'react';
import TopNav from './TopNav';
import { Container } from 'semantic-ui-react';
import Popup from '../Popup';
import NotificationBar from './NotificationBar';
import AlertModal from './AlertModal';
import MobileMenu from './mobile-menu/MobileMenu';

const Header = (props) => {
  const { toggleMenu, menuVisible } = props;
  return (
    <>
      <header className={`header ${menuVisible ? 'header--menu-visible' : ''}`}>
        <NotificationBar />
        <div className={`citipower-header`}>
          <div
            className={`top-nav ${menuVisible ? 'top-nav--menu-visible' : ''}`}
          >
            <Container className="top-nav__container">
              <TopNav toggleMenu={toggleMenu} menuVisible={menuVisible} />
            </Container>
          </div>
          {menuVisible && <MobileMenu />}
        </div>
        <AlertModal />
        <Popup />
      </header>
    </>
  );
};

export default Header;
